import type { FC } from 'react';

import { useGetDocumentFileById } from '@/hooks/queries';

type Props = {
  id: string | undefined;
};

const Breadcrumb: FC<Props> = ({ id }) => {
  if (!id) {
    throw new Error('Missing id param');
  }

  const { data } = useGetDocumentFileById(id);

  return <>{data?.document_file[0].Version || ''}</>;
};

export default Breadcrumb;
